<template>
  <!-- Modal wrapper -->
  <Modal
    @closed="$emit('close')"
    id="modal-feedback"
    class="vlw__feedback"
    title="Feedback"
    :open="true"
    :closable="true"
  >
    <p class="pb-2">
      Heb je een probleem opgemerkt of een idee om de applicatie te verbeteren?
    </p>

    <form @submit.prevent="handleOnSubmit">
      <div class="mb-8">
        <div class="pt-6">
          <div class="mb-2">
            <label for="issueType" class="vl-form__label">
              Waar gaat je melding over?
            </label>
          </div>

          <select
            id="issueType"
            class="vl-select--block vl-select"
            v-model="formData.technicalIssueTypeId"
            required
          >
            <option disabled :value="null">Selecteer een optie</option>
            <option
              v-for="{ id, name } in technicalIssueTypes"
              :key="id"
              :value="id"
            >
              {{ name }}
            </option>
          </select>
        </div>

        <div class="pt-6">
          <div class="mb-2">
            <label for="details" class="vl-form__label">Details</label>
          </div>

          <textarea
            id="details"
            class="vl-textarea w-full"
            rows="5"
            v-model="formData.technicalIssueDetails"
          />
        </div>
      </div>

      <div class="flex justify-end mb-4">
        <VlButton :mod-narrow="true" :mod-loading="isLoading" type="submit">
          Verzenden
        </VlButton>
      </div>

      <VlAlert v-if="error" :mod-error="true" :content="error.message" />
    </form>
  </Modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Feedback',

  data() {
    return {
      error: null,
      formData: {
        technicalIssueDetails: '',
        technicalIssueTypeId: null,
      },
      isLoading: false,
    };
  },

  computed: {
    ...mapState('metadata', ['technicalIssueTypes']),
  },

  methods: {
    handleOnSubmit() {
      this.isLoading = true;

      this.$store
        .dispatch('contact/updateTechnicalIssue', this.formData)
        .then(() => {
          this.isLoading = false;

          this.$emit('close');
        })
        .catch((error) => {
          this.isLoading = false;

          this.error = error;
        });
    },
  },
};
</script>

<style lang="scss">
.vlw__feedback {
  .vlp__modal__dialog {
    min-width: 500px !important;
  }

  textarea.vl-textarea {
    width: 100% !important;
    display: block;
  }
}
</style>